/* eslint-disable import/no-anonymous-default-export */
import { stringify } from "query-string";

import { fetchJson } from "../utils/fetchJson";
import { ADMIN_SITE } from "../constants/contentConstants";
import { PP_ADMIN_REFERRER } from "../constants/storageKeys";

export const apiUrl = () => {
  const referrer = localStorage.getItem(PP_ADMIN_REFERRER);
  return `${
    referrer === "KD"
      ? process.env.REACT_APP_KD_API_URL
      : process.env.REACT_APP_PP_API_URL
  }/api`;
};

const httpClient = (url, options = {}) => {
  if (!options.headers) {
    options.headers = new Headers({ "PP-SITE-IDENTIFIER": ADMIN_SITE });
  }
  return fetchJson(url, options);
};

export default {
  getList: (resource, params) => {
    const { page, perPage } = params.pagination;
    const { field, order } = params.sort;
    const query = {
      sort: JSON.stringify({ [field]: order }),
      page: JSON.stringify(page),
      page_size: JSON.stringify(perPage),
      range: JSON.stringify([(page - 1) * perPage, page * perPage - 1]),
      filter: JSON.stringify(
        params.filter?.id
          ? { ...params.filter, id: [params.filter.id] }
          : params.filter
      ),
    };

    const url = `${apiUrl()}/${resource}/?${stringify(query)}`;
    return httpClient(url).then(({ json }) => ({
      data: json.results,
      total: json.count,
    }));
  },

  getOne: (resource, params) =>
    httpClient(`${apiUrl()}/${resource}/${params.id}/`).then(({ json }) => ({
      data: json,
    })),

  getMany: (resource, params) => {
    const query = {
      filter: JSON.stringify({ id: params.ids }),
    };
    const url = `${apiUrl()}/${resource}/?${stringify(query)}`;
    return httpClient(url).then(({ json }) => ({ data: json.results }));
  },

  getManyReference: (resource, params) => {
    const { page, perPage } = params.pagination;
    const { field, order } = params.sort;
    const query = {
      sort: JSON.stringify({ [field]: order }),
      range: JSON.stringify([(page - 1) * perPage, page * perPage - 1]),
      filter: JSON.stringify({
        ...params.filter,
        [params.target]: params.id,
      }),
    };
    const url = `${apiUrl()}/${resource}/?${stringify(query)}`;

    return httpClient(url).then(({ json }) => ({
      data: json.results,
      total: json.count,
    }));
  },

  update: (resource, params, formData) => {
    const id = params.id ? params.id : params.data.id;
    return httpClient(`${apiUrl()}/${resource}/${id ? `${id}/` : ""}`, {
      method: "PUT",
      body: formData || JSON.stringify(params.data),
    }).then(({ json }) => ({ data: json }));
  },

  updatePatch: (resource, params) => {
    const id = params.id ? params.id : params.data.id;
    return httpClient(`${apiUrl()}/${resource}/${id}/`, {
      method: "PATCH",
      body: JSON.stringify(params.data),
    }).then(({ json }) => ({ data: json }));
  },

  updateMany: (resource, params) => {
    const query = {
      filter: JSON.stringify({ id: params.ids }),
    };
    return httpClient(`${apiUrl()}/${resource}?${stringify(query)}`, {
      method: "PUT",
      body: JSON.stringify(params.data),
    }).then(({ json }) => ({ data: json }));
  },

  create: (resource, params, formData) =>
    httpClient(`${apiUrl()}/${resource}/`, {
      method: "POST",
      body: formData || JSON.stringify(params.data),
    }).then(({ json }) => {
      const id = json.data?.id || json.id;
      return {
        data: { ...params.data, id },
      };
    }),

  delete: (resource, params) =>
    httpClient(`${apiUrl()}/${resource}/${params.id}/`, {
      method: "DELETE",
    }).then(() => ({ data: { id: params.id } })),

  deleteMany: (resource, params) => {
    const query = {
      filter: JSON.stringify({ id: params.ids }),
    };
    return httpClient(`${apiUrl()}/${resource}?${stringify(query)}`, {
      method: "DELETE",
      body: JSON.stringify(params.data),
    }).then(({ json }) => ({ data: json }));
  },
};
